import React from 'react';
import { Table, Button } from 'react-bootstrap';

const IndicesTable = ({ configs, tradingEnabled, handleToggleTrading, setShowAddForm, setShowEditForm, setShowDeleteIndexModal }) => {
  return (
    <div className="bg-white rounded shadow p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Indices</h5>
        <Button variant="primary" size="sm" onClick={() => setShowAddForm(true)}>Add Index</Button>
      </div>
      <div className="table-responsive">
        <Table className="table-bordered text-center">
          <thead className="table-info">
            <tr>
              <th>Index</th>
              <th>Trading</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(configs).map((index) => (
              <tr key={index} className={tradingEnabled[index] ? 'bg-success bg-opacity-10' : ''}>
                <td>{index}</td>
                <td>
                  <Button
                    variant={tradingEnabled[index] ? 'success' : 'secondary'}
                    size="sm"
                    onClick={() => handleToggleTrading(index)}
                  >
                    {tradingEnabled[index] ? 'On' : 'Off'}
                  </Button>
                </td>
                <td>
                  <Button variant="warning" size="sm" className="me-1" onClick={() => setShowEditForm(index)}>Edit</Button>
                  {index !== 'NIFTY' && (
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => setShowDeleteIndexModal(index)}
                    >
                      Delete
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default IndicesTable;